<template>
  <full-container>
    <div class="paper" v-if="detail">
      <el-radio-group v-model="template" size="mini" style="margin-bottom: 5px">
        <el-radio-button :label="1">常规样式</el-radio-button>
        <el-radio-button :label="2">携带备注</el-radio-button>
      </el-radio-group>
      <table id="print" v-if="template == 1">
        <thead>
          <tr>
            <th colspan="8" style="padding: 10px">
              <div class="title">
                <h1 style="font-size: 20px; letter-spacing: 5px">销售申请单</h1>
                <p style="color: #f56c6c">{{ detail.Code }}</p>
                <p class="toolbar" style="margin-top: 10px">
                  <label>部门：{{ detail.Dept.Name }}</label>
                  <label>客户：{{ detail.Customer }}</label>
                  <label>时间：{{ $utils.common.parseTime(detail.CreateTime, '{y} 年 {m} 月 {d} 日') }}</label>
                  <label />
                </p>
                <vue-qr class="qr" :margin="0" :text="detail.Code" :size="64" />
              </div>
            </th>
          </tr>
          <tr>
            <th>商品编码</th>
            <th colspan="3">品名及规格</th>
            <th>单位</th>
            <th>数量</th>
            <th>单价</th>
            <th>金额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in detail.Items" :key="index">
            <th>{{ row.Code }}</th>
            <td colspan="3">{{ row.Name }} {{ row.Spec }}</td>
            <th>{{ row.Unit }}</th>
            <th>{{ row.Quantity }}</th>
            <th>
              <template v-if="row.Price">￥{{ row.Price }}</template>
            </th>
            <th>
              <template v-if="row.Price">￥{{ row.Amount }}</template>
            </th>
          </tr>
        </tbody>
        <tr>
          <th>合计</th>
          <td colspan="7" style="letter-spacing: 5px">
            {{ $utils.common.formatCnmoney(totalPrice || 0) }}
            <label class="text-price text-danger">{{ totalPrice }}</label>
          </td>
        </tr>
        <tfoot>
          <tr>
            <td colspan="8" style="white-space: pre-wrap">{{ detail.Remarks }} {{ detail.Linkman }} {{ detail.Linktel }} {{ detail.Address }} {{ detail.Code }}</td>
          </tr>
          <tr>
            <td colspan="2">审核：</td>
            <td colspan="2">财务：</td>
            <td colspan="2">部门经理：</td>
            <td colspan="2">经办人：</td>
          </tr>
        </tfoot>
      </table>
      <table id="print" v-else-if="template == 2">
        <thead>
          <tr>
            <th colspan="12" style="padding: 10px">
              <div class="title">
                <h1 style="font-size: 20px; letter-spacing: 5px">销售申请单</h1>
                <p style="color: #f56c6c">{{ detail.Code }}</p>
                <p class="toolbar" style="margin-top: 10px">
                  <label>部门：{{ detail.Dept.Name }}</label>
                  <label>客户：{{ detail.Customer }}</label>
                  <label>时间：{{ $utils.common.parseTime(detail.CreateTime, '{y} 年 {m} 月 {d} 日') }}</label>
                  <label />
                </p>
                <vue-qr class="qr" :margin="0" :text="detail.Code" :size="64" />
              </div>
            </th>
          </tr>
          <tr>
            <th>商品编码</th>
            <th colspan="3">品名及规格</th>
            <th>单位</th>
            <th>数量</th>
            <th>单价</th>
            <th>金额</th>
            <th colspan="4">备注</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in detail.Items" :key="index">
            <th>{{ row.Code }}</th>
            <td colspan="3">{{ row.Name }} {{ row.Spec }}</td>
            <th>{{ row.Unit }}</th>
            <th>{{ row.Quantity }}</th>
            <th>
              <template v-if="row.Price">￥{{ row.Price }}</template>
            </th>
            <th>
              <template v-if="row.Price">￥{{ row.Amount }}</template>
            </th>
            <td colspan="4">{{ row.Remarks }}</td>
          </tr>
        </tbody>
        <tr>
          <th>合计</th>
          <td colspan="11" style="letter-spacing: 5px">
            {{ $utils.common.formatCnmoney(totalPrice || 0) }}
            <label class="text-price text-danger">{{ totalPrice }}</label>
          </td>
        </tr>
        <tfoot>
          <tr>
            <td colspan="12" style="white-space: pre-wrap">{{ detail.Remarks }} {{ detail.Linkman }} {{ detail.Linktel }} {{ detail.Address }} {{ detail.Code }}</td>
          </tr>
          <tr>
            <td colspan="3">审核：</td>
            <td colspan="3">财务：</td>
            <td colspan="3">部门经理：</td>
            <td colspan="3">经办人：</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div slot="footer" style="text-align: center">
      <el-button type="primary" icon="el-icon-edit" @click="$router.push({ path: 'form', query: { id: detail.Id } })">修改</el-button>
      <el-button type="primary" icon="el-icon-printer" v-print="'#print'">打印</el-button>
    </div>
  </full-container>
</template>

<script>
export default {
  components: {
    vueQr: () => import('vue-qr')
  },
  data () {
    return {
      loading: false,
      template: 1,
      detail: null
    }
  },
  created () {
    this.$apis.product.presale.detail({ id: this.$route.params.id }).then(res => {
      this.detail = res || []
    })
  },
  computed: {
    totalQuantity () {
      return this.detail.Items.reduce((acc, cur) => {
        return acc + (cur.Quantity || 0)
      }, 0)
    },
    totalPrice () {
      let val = this.detail.Items.reduce((acc, cur) => {
        return acc + (cur.Amount || 0)
      }, 0)
      return Math.round(val * 100) / 100
    }
  }
}
</script>


<style lang="scss" scoped>
:deep(.el-scrollbar) {
  &__view {
    height: unset;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .paper {
      padding: 40px;
      background: #fff;
      width: 960px;
      table {
        min-height: 600px;
      }
    }
  }
}
table {
  font-size: 12px;
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border: 1px solid;
  border-collapse: collapse;
  tbody {
    height: 100%;
    vertical-align: top;
  }
  tr {
    td,
    th {
      border: 1px solid;
      padding: 5px 10px;
      word-break: break-all;
      height: 30px;
    }
    th {
      text-align: center;
      font-weight: normal;
    }
    .flex {
      height: 100%;
      min-height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
.title {
  position: relative;
  .qr {
    position: absolute;
    right: 0px;
    top: 0px;
  }
}
</style>